import { render, staticRenderFns } from "./AssignmentCollection.vue?vue&type=template&id=22df3ef6"
import script from "./AssignmentCollection.vue?vue&type=script&lang=js"
export * from "./AssignmentCollection.vue?vue&type=script&lang=js"
import style0 from "./AssignmentCollection.vue?vue&type=style&index=0&id=22df3ef6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports